import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { AppCheckTokenResult } from "@firebase/app-check";
import { 
  // catchError, defer, from, 
  Observable, 
  // of 
} from "rxjs";
// import { switchMap, take } from "rxjs/operators";
// import { AppCheckService } from "./app-check.service";

@Injectable({ providedIn: "root" })
export class AppCheckInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  return next.handle(request);
  // Comment out the above line and uncomment the following lines
    // return defer(() => {
    //   return from(
    //     this.appCheckService.getToken().catch(err => {
    //       console.warn('AppCheck token acquisition failed in interceptor:', err);
    //       return undefined; // Continue without token on error
    //     })
    //   );
    // }).pipe(
    //   take(1),
    //   catchError(error => {
    //     console.error('Error in AppCheck interceptor:', error);
    //     // Continue with the original request even if token acquisition fails
    //     return of(undefined);
    //   }),
    //   switchMap((token: AppCheckTokenResult | undefined) => {
    //     if (token && token?.token) {
    //       request = request.clone({
    //         setHeaders: { "X-Firebase-AppCheck": token?.token },
    //       });
    //     }
    //     return next.handle(request);
    //   })
    // );

  }
}
